import EuFormContainer from 'components/eu/EuFormContainer';

export default function DeMigrationFormPage() {
  const contentfulId = '5AMNtDCWKeK5931JB0x2tj'; // Germany Form Page
  const country = 'GERMANY';
  return <EuFormContainer contentfulId={contentfulId} country={country} />;
}
